/**
 * FormField · txn kit (presentation only)
 * Overline label (SO language) + required marker + control slot + error/hint.
 * No validation logic — callers pass `error`/`required` as plain props.
 */
import React from "react";

export default function FormField({
  label,
  required = false,
  htmlFor,
  error = "",
  hint = "",
  className = "",
  children,
  testId,
}) {
  return (
    <div className={className} data-testid={testId}>
      {label && (
        <label htmlFor={htmlFor} className="overline mb-1.5 flex items-center gap-1">
          <span>{label}</span>
          {required && <span className="text-red-400" aria-hidden="true">*</span>}
        </label>
      )}
      {children}
      {error ? (
        <div className="mt-1 text-[11px] font-medium text-red-400" data-testid={testId ? `${testId}-error` : undefined}>
          {error}
        </div>
      ) : hint ? (
        <div className="mt-1 text-[11px] text-[var(--fg-3)]">{hint}</div>
      ) : null}
    </div>
  );
}
